import {
    FieldInputProps,
    FieldProps,
    connect as FormikConnect,
    FormikProps,
} from "formik";
import React, { Fragment, useState } from "react";
import Select from "react-select";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { TextFieldProps } from "@components/Form/FormFields/TextField/textField.component.class";
import { FormFeedback } from "@components/General/Form/formFeedback.component";

import { BaseField } from "../Base/base.component";
import "./selectField.scss";

type SelectFieldProps = TextFieldProps & {
    optionList: any;
    onChange?: (value: any) => void;
};

const SelectField = ({
    placeholder,
    autoComplete,
    onChange,
    optionList,
    disabled,
    "aria-label": ariaLabel,
    ...baseFieldProps
}: SelectFieldProps) => {
    const { t } = useGranite();

    const [isFocussed, setIsFocussed] = useState(false);

    const getValue = (field: FieldInputProps<unknown>) =>
        !isFocussed
            ? (optionList &&
                  ((field.value &&
                      optionList.find(
                          (option: any) => option.value === field.value,
                      )) ||
                      optionList[0])) ||
              ""
            : "";

    const handleOnChange =
        (field: FieldInputProps<unknown>, form: FormikProps<unknown>) =>
        (option: any) => {
            form.setFieldTouched(field.name, true, false);
            form.setFieldValue(field.name, option.value, false);
            if (onChange) {
                onChange(option.value);
            }
            setTimeout(() => {
                form.validateField(field.name);
            });
        };

    const handleOnFocus = () => setIsFocussed(true);

    const handleOnBlur = () => setIsFocussed(false);

    return (
        <BaseField {...baseFieldProps}>
            {({ field, meta, form }: FieldProps) => {
                return (
                    <Fragment>
                        <Select
                            {...field}
                            id={field.name}
                            name={field.name}
                            openMenuOnFocus={true}
                            classNamePrefix="select-box"
                            className={
                                meta.touched
                                    ? !meta.error
                                        ? "select-box--is-valid"
                                        : "select-box--is-invalid"
                                    : ""
                            }
                            placeholder={isFocussed ? "" : placeholder}
                            options={optionList}
                            isSearchable={true}
                            // @ts-ignore
                            autocomplete={autoComplete}
                            blurInputOnSelect={true}
                            onBlur={handleOnBlur}
                            onFocus={handleOnFocus}
                            value={getValue(field)}
                            noOptionsMessage={() =>
                                t("general.selectBox.no.options")
                            }
                            onChange={handleOnChange(field, form)}
                            isDisabled={disabled}
                            aria-label={ariaLabel}
                        />
                        {meta.touched && !!meta.error && (
                            <FormFeedback className={"d-block"}>
                                {meta.error}
                            </FormFeedback>
                        )}
                    </Fragment>
                );
            }}
        </BaseField>
    );
};

export default FormikConnect(SelectField);
